import { render } from "./ucloud-annex-policy.vue?vue&type=template&id=e88c81a6&scoped=true&ts=true"
import script from "./ucloud-annex-policy.vue?vue&type=script&lang=ts"
export * from "./ucloud-annex-policy.vue?vue&type=script&lang=ts"

import "./ucloud-annex-policy.vue?vue&type=style&index=0&id=e88c81a6&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e88c81a6"]])

export default __exports__